import { render } from "./ButtonGroup.vue?vue&type=template&id=90f5a014&scoped=true"
import script from "./ButtonGroup.vue?vue&type=script&lang=ts"
export * from "./ButtonGroup.vue?vue&type=script&lang=ts"

import "./ButtonGroup.vue?vue&type=style&index=0&id=90f5a014&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-90f5a014"

export default script